jQuery(function($){

    // Arrays to store selected files (File objects)
    let imageFiles = [];
    let videoFiles = [];

    // Helper to render image previews
    function renderImagePreviews() {
        let $container = $('#ptdf-image-previews').empty();
        imageFiles.forEach((file, i) => {
            let url = URL.createObjectURL(file);
            $container.append(
                `<div class="position-relative">
                    <img src="${url}" class="rounded" style="width:80px;height:80px;object-fit:cover;">
                    <button type="button" class="btn-close position-absolute top-0 end-0 bg-white p-1 ptdf-remove-image" data-index="${i}" style="z-index:2;"></button>
                </div>`
            );
        });
    }

    // Helper to render video previews
    function renderVideoPreviews() {
        let $container = $('#ptdf-video-previews').empty();
        videoFiles.forEach((file, i) => {
            let url = URL.createObjectURL(file);
            $container.append(
                `<div class="position-relative">
                    <video src="${url}" class="rounded" style="width:80px;height:80px;object-fit:cover;" controls></video>
                    <button type="button" class="btn-close position-absolute top-0 end-0 bg-white p-1 ptdf-remove-video" data-index="${i}" style="z-index:2;"></button>
                </div>`
            );
        });
    }

    // Handle clicking dropzone (to open file selector)
    $('#ptdf-image-dropzone').on('click', function(e){
        if(e.target.tagName === 'INPUT') return;
        $('#images-input').click();
    });
    $('#ptdf-video-dropzone').on('click', function(e){
        if(e.target.tagName === 'INPUT') return;
        $('#videos-input').click();
    });

    // Handle selecting files via input
    $('#images-input').on('change', function(e){
        Array.from(e.target.files).forEach(file => {
            if(!imageFiles.some(f => f.name === file.name && f.size === file.size)) imageFiles.push(file);
        });
        renderImagePreviews();
        $(this).val(''); // clear file input
    });
    $('#videos-input').on('change', function(e){
        Array.from(e.target.files).forEach(file => {
            if(!videoFiles.some(f => f.name === file.name && f.size === file.size)) videoFiles.push(file);
        });
        renderVideoPreviews();
        $(this).val('');
    });

    // Remove selected image
    $('#ptdf-image-previews').on('click', '.ptdf-remove-image', function(){
        let i = $(this).data('index');
        imageFiles.splice(i,1);
        renderImagePreviews();
    });
    // Remove selected video
    $('#ptdf-video-previews').on('click', '.ptdf-remove-video', function(){
        let i = $(this).data('index');
        videoFiles.splice(i,1);
        renderVideoPreviews();
    });

    // Drag-and-drop support (optional)
    $('#ptdf-image-dropzone').on('dragover', function(e){ e.preventDefault(); $(this).addClass('bg-light'); });
    $('#ptdf-image-dropzone').on('dragleave', function(e){ e.preventDefault(); $(this).removeClass('bg-light'); });
    $('#ptdf-image-dropzone').on('drop', function(e){
        e.preventDefault(); $(this).removeClass('bg-light');
        let files = Array.from(e.originalEvent.dataTransfer.files);
        files.filter(f => f.type.startsWith('image/')).forEach(file => {
            if(!imageFiles.some(f => f.name === file.name && f.size === file.size)) imageFiles.push(file);
        });
        renderImagePreviews();
    });
    $('#ptdf-video-dropzone').on('dragover', function(e){ e.preventDefault(); $(this).addClass('bg-light'); });
    $('#ptdf-video-dropzone').on('dragleave', function(e){ e.preventDefault(); $(this).removeClass('bg-light'); });
    $('#ptdf-video-dropzone').on('drop', function(e){
        e.preventDefault(); $(this).removeClass('bg-light');
        let files = Array.from(e.originalEvent.dataTransfer.files);
        files.filter(f => f.type.startsWith('video/')).forEach(file => {
            if(!videoFiles.some(f => f.name === file.name && f.size === file.size)) videoFiles.push(file);
        });
        renderVideoPreviews();
    });

    // On modal open, clear files/previews
    $('#newPostModal').on('show.bs.modal', function(){
        imageFiles = [];
        videoFiles = [];
        renderImagePreviews();
        renderVideoPreviews();
        $('#ptdf-new-post-form')[0].reset();
    });

    // Handle form submit (AJAX)
    $('#ptdf-new-post-form').on('submit', async function(e){
        e.preventDefault();
        let userId = $('#ptdf-post-submit-btn').data('user-id')
        let formData = new FormData(this);
        formData.append('action', 'ptdf_submit_post');
        formData.append('nonce', ptdfNetworkAjax.nonce);


        imageFiles.forEach((file,i) => formData.append('images[]', file));

        $('#ptdf-upload-backdrop').fadeIn(120);
        $('#ptdf-upload-progress').css('width','0%').text('0%');
        let $btn = $(this).find('button[type="submit"]');
        $btn.prop('disabled', true).text('Posting...');

        // 1. Create the post first (and upload images as before)
        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            method: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            xhr: function() {
                let xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", function(evt){
                    if (evt.lengthComputable) {
                        let percent = Math.round((evt.loaded / evt.total) * 100);
                        $('#ptdf-upload-progress').css('width', percent + '%').text(percent + '%');
                    }
                }, false);
                return xhr;
            },
            success: async function(resp){
                if(!resp.success){
                    $btn.prop('disabled', false).text('Post');
                    $('#ptdf-upload-backdrop').fadeOut(150);
                    $('#ptdf-upload-progress').css('width','0%').text('0%');
                    alert(resp.data || 'Error adding post');
                    return;
                }

                let post_id = resp.data.post_id;


                let failedVideos = [];
                for (let i = 0; i < videoFiles.length; i++) {
                    let file = videoFiles[i];

                    // Optional: Progress feedback
                    $('#ptdf-upload-progress').css('width', ((i/videoFiles.length)*100) + '%').text('A carregar video ' + (i+1) + '/' + videoFiles.length);

                    let bunnyResp;
                    try {

                        bunnyResp = await uploadVideoToBunnyPHPStyle(file, function(percent){
                            $('#ptdf-upload-progress').css('width', percent + '%').text('A carregar video ' + (i+1) + '/' + videoFiles.length + ': ' + percent + '%');
                        }, userId)
                    } catch (e) {
                        failedVideos.push(file.name);
                        continue;
                    }

                    // Now register the uploaded Bunny video in WP/ACF
                    await $.post(ptdfNetworkAjax.ajaxurl, {
                        action: 'register_bunny_video',
                        guid: bunnyResp.guid,         // Use GUID from Bunny response!
                        filename: userId+'_'+file.name,
                        post_id: post_id
                    }).done(function(resp){
                        if (!resp.success) {
                            failedVideos.push(file.name);
                        }
                    });
                }

                $btn.prop('disabled', false).text('Post');
                $('#ptdf-upload-backdrop').fadeOut(150);
                $('#ptdf-upload-progress').css('width','0%').text('0%');

                if (failedVideos.length > 0) {
                    alert('These videos failed to upload: ' + failedVideos.join(', '));
                }

                /*
                let modalEl = document.getElementById('newPostModal');
                let modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                modal.hide();
                $('.modal-backdrop').slice(1).remove();
                 */
                $('#ptdf-new-post-form')[0].reset();

                imageFiles = [];
                videoFiles = [];
                renderImagePreviews();
                renderVideoPreviews();

                $.post(ptdfNetworkAjax.ajaxurl, {
                    action: 'get_post_html',
                    post_id: post_id
                }, function(postResp){
                    if(postResp.success && postResp.data && postResp.data.html){
                        $('#ptdf-posts').prepend(postResp.data.html);
                        let $swiper = $('#ptdf-posts .ptdf-swiper').first();
                        if($swiper.length){
                            new Swiper($swiper[0], {
                                slidesPerView: 1,
                                spaceBetween: 10,
                                navigation: {
                                    nextEl: $swiper.find('.swiper-button-next')[0],
                                    prevEl: $swiper.find('.swiper-button-prev')[0],
                                },
                                pagination: {
                                    el: $swiper.find('.swiper-pagination')[0],
                                    clickable: true,
                                },
                                lazy: true,
                            });
                        }
                    }
                });


            },
            error: function(){
                $btn.prop('disabled', false).text('Post');
                $('#ptdf-upload-backdrop').fadeOut(150);
                $('#ptdf-upload-progress').css('width','0%').text('0%');
                alert('Error connecting to server');
            }
        });
    });

    $('#ptdf-posts').on('click', '.ptdf-likes-popup-trigger', function(e){
        e.preventDefault();
        var $link = $(this);
        var activityId = $link.data('activity');
        var count = $link.data('count');

        // Show loading
        $('#ptdf-likes-modal-body').html('<div class="text-center p-4">Loading...</div>');
        var modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('ptdfLikesModal'));
        modal.show();

        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ptdf_get_post_likers',
                activity_id: activityId
            },
            success: function(resp){
                if(resp.success && resp.data.users.length) {
                    var html = '<ul class="list-unstyled">';
                    resp.data.users.forEach(function(user){
                        html += '<li class="d-flex align-items-center mb-2">';
                        html += '<a href="'+user.profile_url+'" target="_blank"><img src="'+user.avatar+'" style="width:36px;height:36px;border-radius:50%;margin-right:10px;"></a>';
                        html += '<a href="'+user.profile_url+'" class="fw-bold text-dark" target="_blank">'+user.name+'</a>';
                        html += '</li>';
                    });
                    html += '</ul>';
                } else {
                    var html = '<div class="text-muted">No likes yet.</div>';
                }
                $('#ptdf-likes-modal-body').html(html);
            },
            error: function(){
                $('#ptdf-likes-modal-body').html('<div class="text-danger">Could not load users.</div>');
            }
        });
    });

    $('#ptdf-posts').on('click', '.ptdf-pin-post', function(e){
        e.preventDefault();
        var $btn = $(this);
        var postId = $btn.data('post-id');
        $('#ptdf-loading-overlay').show();
        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ptdf_pin_post',
                post_id: postId,
                nonce: ptdfNetworkAjax.nonce
            },
            success: function(resp){
                $('#ptdf-loading-overlay').hide();
                if(resp.success){
                    // Optionally show a toast: "Pinned!"
                    // Reload posts area to reflect change (requery for order)
                    location.reload(); // or do ajax refresh if you have that
                }else{
                    $('#ptdf-loading-overlay').hide();
                    alert(resp.data || 'Could not pin');
                }
            }
        });
    });
    $('#ptdf-posts').on('click', '.ptdf-unpin-post', function(e){
        e.preventDefault();
        var $btn = $(this);
        var postId = $btn.data('post-id');
        $('#ptdf-loading-overlay').show();
        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ptdf_unpin_post',
                post_id: postId,
                nonce: ptdfNetworkAjax.nonce
            },
            success: function(resp){
                $('#ptdf-loading-overlay').hide();
                location.reload(); // Or ajax refresh of posts area
            },
            error: function() {
                $('#ptdf-loading-overlay').hide();
                alert('Error');
            }
        });
    });
    $('#ptdf-posts').on('click', '.ptdf-delete-post', function(e){
        e.preventDefault();
        if(!confirm('Delete this post?')) return;
        var $btn = $(this);
        var postId = $btn.data('post-id');
        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ptdf_delete_post',
                post_id: postId,
                nonce: ptdfNetworkAjax.nonce
            },
            success: function(resp){
                if(resp.success){
                    $btn.closest('.ptdf-post-item').remove();
                }else{
                    alert(resp.data || 'Could not delete');
                }
            }
        });
    });

    async function uploadVideoToBunnyPHPStyle(file, onProgress, userId) {
        const apiKey = 'd8100ce7-9ae7-4d79-85b44220521b-6252-405e';
        const libraryId = '477709';

        // 1. Create slot (get GUID)
        const title = userId+'_'+file.name.replace(/\.[^/.]+$/, ""); // remove extension
        const createSlotResp = await fetch(`https://video.bunnycdn.com/library/${libraryId}/videos`, {
            method: 'POST',
            headers: {
                'AccessKey': apiKey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ title: title })
        });
        if (!createSlotResp.ok) throw new Error('Failed to create Bunny slot');
        const slotData = await createSlotResp.json();
        if (!slotData.guid) throw new Error('No GUID returned from Bunny');
        const videoGuid = slotData.guid;

        // 2. Upload the video to the slot
        await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', `https://video.bunnycdn.com/library/${libraryId}/videos/${videoGuid}`);
            xhr.setRequestHeader('AccessKey', apiKey);
            xhr.setRequestHeader('Content-Type', 'application/octet-stream');
            xhr.upload.onprogress = function(e){
                if (e.lengthComputable && typeof onProgress === 'function') {
                    let percent = Math.round((e.loaded / e.total) * 100);
                    onProgress(percent);
                }
            };
            xhr.onload = function() {
                if (xhr.status >= 200 && xhr.status < 300) resolve();
                else reject(new Error('Failed to upload video file to cdn'));
            };
            xhr.onerror = function() { reject(new Error('Failed to upload video file to cdn')); };
            xhr.send(file);
        });

        // 3. Build URLs
        const playbackUrl = `https://iframe.mediadelivery.net/embed/${libraryId}/${videoGuid}`;
        // If you want the direct MP4 (for a given resolution, e.g. 720p)
        const directUrl = `https://vz-b0b57f19-e78.b-cdn.net/${videoGuid}/play_720p.mp4`;

        return {
            guid: videoGuid,
            playback_url: playbackUrl,
            direct_url: directUrl
        };
    }
});